var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag && [1, 2, 3, 4, 5, 6].includes(_vm.tag) ? ("h" + _vm.tag) : 'p',{tag:"component",class:[_vm.align ? _vm.align : '', _vm.getSize, _vm.weight ? _vm.weight : '']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }